import { ResourceList } from './resourceList';

window.addEventListener("load", () => {
  new ResourceList();
})
